/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { hubsSocket } from '../services/socket.IO';
import { setFileSend } from '../store/ducks/sideMenu/actions';
import warn from '../constants/toast';

const Socket = () => {
  const dispatch = useDispatch();
  const socketFile = useMemo(() => hubsSocket.getConnectionHubAgendamento(), []);
  const socketSchedule = useMemo(() => hubsSocket.getConnectionHubAdmin(), []);

  useEffect(() => {
    if (!socketFile) {
      return;
    }

    socketFile
      .start()
      .then(() => {
        socketFile.on('ConfirmacaoImportacaoArquivo', (sucesso, mensagem) => {
          if (sucesso) {
            dispatch(setFileSend(true));
            warn.wargingSuccess(`${mensagem}!`);
          } else {
            warn.wargingError(`${JSON.stringify(mensagem)}!`);
          }
        });
      })
      .catch(() => {});

    return () => {
      (async () => await socketFile.stop())();
    };
  }, [socketFile]);

  useEffect(() => {
    if (!socketSchedule) {
      return;
    }

    socketSchedule
      .start()
      .then(() => {
        socketSchedule.on('ConfirmacaoCriacaoAgenda', (sucesso, mensagem) => {
          if (sucesso) {
            dispatch(setFileSend(true));
            warn.wargingSuccess(`${mensagem}!`);
          } else {
            warn.wargingError(`${JSON.stringify(mensagem)}!`);
          }
        });
      })
      .catch(() => {});

    return () => {
      (async () => await socketSchedule.stop())();
    };
  }, [socketSchedule]);
};
export default Socket;
